(function(angular){
	'use strict';
	
	var opportunityFundChartObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			'darkTheme' : '<?'
		},
		controller: [
			'$filter',
			'$scope',
			'$timeout',
			'$window',
			'APP_BASE_PATH',
			'Big',
			OpportunityFundChartFunction
		],
		controllerAs: 'opportunityFundChart'
	};
	
	angular
		.module('opportunityFundModule')
		.component('opportunityFundChart', opportunityFundChartObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/opportunity-fund/opportunity-fund-chart.html';
	}
	
	function OpportunityFundChartFunction(
		$filter,
		$scope,
		$timeout,
		$window,
		APP_BASE_PATH,
		Big
	){
		var opportunityFundChart = this;
		var capitalGainsTaxRate = new Big('.238');

		opportunityFundChart.$onInit = function() {
			opportunityFundChart.amountOptions = [{
				label: '$25,000',
				value: 25000
			},{
				label: '$50,000',
				value: 50000
			},{
				label: '$100,000',
				value: 100000
			},{
				label: '$250,000',
				value: 250000
			},{
				label: '$500,000',
				value: 500000
			},{
				label: '$1,000,000',
				value: 1000000
			}];

			opportunityFundChart.annualReturnOptions = [{
				label: '1%',
				value: 0.01
			},{
				label: '2%',
				value: 0.02
			},{
				label: '3%',
				value: 0.03
			},{
				label: '4%',
				value: 0.04
			},{
				label: '5%',
				value: 0.05
			},{
				label: '6%',
				value: 0.06
			},{
				label: '7%',
				value: 0.07
			},{
				label: '8%',
				value: 0.08
			},{
				label: '9%',
				value: 0.09
			},{
				label: '10%',
				value: 0.10
			},{
				label: '11%',
				value: 0.11
			},{
				label: '12%',
				value: 0.12
			}];

			opportunityFundChart.basePath = APP_BASE_PATH;
			opportunityFundChart.initialAmount = opportunityFundChart.amountOptions[0];
			opportunityFundChart.annualReturn = opportunityFundChart.annualReturnOptions[5];
			opportunityFundChart.opportunityFundLabel = angular.isDefined(opportunityFundChart.darkTheme) ? 'Fundrise Opportunity Fund' : 'Opportunity Fund';
			var xAxisColor = angular.isDefined(opportunityFundChart.darkTheme) ? '#ffffff' : '#55595E';
			var yAxisColor = angular.isDefined(opportunityFundChart.darkTheme) ? '#ffffff' : '#55595E';
			var axisFontSize = angular.isDefined(opportunityFundChart.darkTheme) ? '16px' : '14px';

			var chartOptions = {
				chart: {
					type: 'column',
					spacing: [0,0,0,0]
				},
				plotOptions: {
					series: {
						borderWidth: 0,
						dataLabels: {
							allowOverlap: true,
							enabled: false,
							formatter: function() {
								return $filter('currency')(this.y, '$', 0);
							},
							inside: false,
							style: {	
								fontSize: '14px',
								fontWeight: 'bold',
								textOutline: 'none'
							}
						}
					}
				},
				series: [{
					color: {
						linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
						stops: [
							[0, '#0066cc'],
							[1, '#007fff']
						]
					},
					name: 'Traditional stock portfolio'
				},{
					color: {
						linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
						stops: [
							[0, '#FF8000'],
							[1, '#FFAA00']
						]
					},
					name: opportunityFundChart.opportunityFundLabel
				}],
				xAxis: {
					categories: [
						'5 yrs',
						'7 ys',
						'10 yrs'
					],
					labels: {
						style: {
							color: xAxisColor
						}
					}
				},
				yAxis: {
					labels: {
						formatter: function() {
							return '$' + this.axis.defaultLabelFormatter.call(this);
						}
					}
				},
				responsive: {
					rules: [{
						condition: {
							minWidth: 480
						},
						chartOptions: {
							plotOptions: {
								series: {
									dataLabels: {
										enabled: true
									}
								}
							},
							xAxis: {
								categories: [
									'Hold for 5 years',
									'Hold for 7 years',
									'Hold for 10 years'
								],
								labels: {
									style: {
										color: xAxisColor,
										fontSize: axisFontSize
									}
								}
							},
							yAxis: {
								title: {
									enabled: true,
									text: 'After-tax value',
									style: {
										color: yAxisColor,
										fontSize: axisFontSize
									}
								}
							}
						}
					}]
				}
			};

			var chartData = buildData();

			chartOptions.series[0].data = chartData[0].data;
			chartOptions.series[1].data = chartData[1].data;

			opportunityFundChart.highchartsObject = chartOptions;
			opportunityFundChart.shareLink = $window.location.origin + $window.location.pathname + "#ofund__calculator";
		};


		$scope.$on('highchart.load', function(event, renderedChartObject) {
			setComparisonStyles(renderedChartObject);
		});

		$scope.$on('highchart.render', function(event, renderedChartObject) {
			setComparisonStyles(renderedChartObject);
		});

		function setComparisonStyles(renderedChartObject) {
			var fundriseSeriesOffsetTop = renderedChartObject.series[1].data[2].plotY;
			var traditionalSeriesOffsetTop = renderedChartObject.series[0].data[2].plotY;
			var top = fundriseSeriesOffsetTop;
			var height = traditionalSeriesOffsetTop - fundriseSeriesOffsetTop;

			$timeout(function() {
				opportunityFundChart.comparisonStyle = {
					height: height + 'px',
					top: top + 'px'
				};
			});
		}

		function buildData() {
			var bigInitialAmount = new Big(opportunityFundChart.initialAmount.value);
			var bigAnnualReturn = new Big(opportunityFundChart.annualReturn.value);
			var bigOne = new Big(1);
			var bigNegativeOne = new Big(-1);
			var bigPointNine = new Big (0.9);
			var bigPointEightFive = new Big(0.85);

			//traditional
			var initialRollOverTax = (bigInitialAmount.times(bigOne.minus(capitalGainsTaxRate))).minus(bigInitialAmount);
			var amountMinusInitialTax = bigInitialAmount.plus(initialRollOverTax);
			var initialNewGains = amountMinusInitialTax.times(bigOne.plus(bigAnnualReturn).pow(1)).minus(amountMinusInitialTax);
			var initialCapitalGainsTax = initialNewGains.times(capitalGainsTaxRate).times(bigNegativeOne);
			var yearOneBalance = bigInitialAmount.plus(initialRollOverTax).plus(initialNewGains).plus(initialCapitalGainsTax);
			var newGainsFifth = amountMinusInitialTax.times(bigOne.plus(bigAnnualReturn).pow(5)).minus(amountMinusInitialTax);
			var capitalGainsTaxFifth = newGainsFifth.times(capitalGainsTaxRate).times(bigNegativeOne);
			var yearFiveBalance = amountMinusInitialTax.plus(newGainsFifth).plus(capitalGainsTaxFifth);

			var newGainsSeventh = amountMinusInitialTax.times(bigOne.plus(bigAnnualReturn).pow(7)).minus(amountMinusInitialTax);
			var capitalGainsTaxSeventh = newGainsSeventh.times(capitalGainsTaxRate).times(bigNegativeOne);
			var yearSevenBalance = amountMinusInitialTax.plus(newGainsSeventh).plus(capitalGainsTaxSeventh);

			var newGainsTenth = amountMinusInitialTax.times(bigOne.plus(bigAnnualReturn).pow(10)).minus(amountMinusInitialTax);
			var capitalGainsTaxTenth = newGainsTenth.times(capitalGainsTaxRate).times(bigNegativeOne);
			var yearTenthBalance = amountMinusInitialTax.plus(newGainsTenth).plus(capitalGainsTaxTenth);

			//fundrise
			var fundRollOverTax = bigInitialAmount.times(capitalGainsTaxRate).times(bigPointNine).times(bigNegativeOne);
			var fundriseGainsFifth = bigInitialAmount.times(bigOne.plus(bigAnnualReturn).pow(5)).minus(bigInitialAmount);
			var fundCapitalGainsTaxFifth = fundriseGainsFifth.times(capitalGainsTaxRate).times(bigNegativeOne);
			var fundYearFiveBalance = bigInitialAmount.plus(fundRollOverTax).plus(fundriseGainsFifth).plus(fundCapitalGainsTaxFifth);

			var fundRollOverTaxSeven = bigInitialAmount.times(capitalGainsTaxRate).times(bigPointEightFive).times(bigNegativeOne);
			var fundriseGainsSeven = bigInitialAmount.times(bigOne.plus(bigAnnualReturn).pow(7)).minus(bigInitialAmount);
			var fundCapitalGainsTaxSeven = fundriseGainsSeven.times(capitalGainsTaxRate).times(bigNegativeOne);
			var fundYearSevenBalance = bigInitialAmount.plus(fundRollOverTaxSeven).plus(fundriseGainsSeven).plus(fundCapitalGainsTaxSeven);

			var fundriseGainsTenth = bigInitialAmount.times(bigOne.plus(bigAnnualReturn).pow(10)).minus(bigInitialAmount);
			var fundYearTenthBalance = bigInitialAmount.plus(fundriseGainsTenth).plus(fundRollOverTaxSeven);

			opportunityFundChart.tenYearReturnDifference = fundYearTenthBalance - yearTenthBalance;

			return [{
					name: 'Traditional Investment',
					data: [parseInt(yearFiveBalance), parseInt(yearSevenBalance), parseInt(yearTenthBalance)]
				}, {
					name: 'Fundrise Opportunity Fund',
					data: [parseInt(fundYearFiveBalance), parseInt(fundYearSevenBalance), parseInt(fundYearTenthBalance)]
				}];		
		}

		opportunityFundChart.updateChart = function() {
			var chartData = buildData();
			opportunityFundChart.highchartsObject = {
				series: [{
					data: chartData[0].data
				},{
					data: chartData[1].data
				}]
			};
		};	
	}
})(window.angular);